import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import requests from 'app/requests/ContainerUnitPriceRule.requests'
import {
    ContainerUnitPrice,
} from '../ProformaInvoices.types'

export default function useGetContainerUnitPrice(id: number) {
    return useRequest<ContainerUnitPrice>({
        key: RequestKeys.getContainerUnitPrice,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}
